import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tun-prelisten-forward-icon',
  templateUrl: './prelisten-forward-icon.component.html',
  styleUrls: ['./prelisten-forward-icon.component.scss']
})
export class PrelistenForwardIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
